import * as hubLVideoUtils from 'FileManagerCore/utils/hubLVideo';
export const isHubLVideo = hubLVideoUtils.isHubLVideo;
export const isHubSpotVideo2 = hubLVideoUtils.isHubSpotVideo2;
export const getHubLVideoParamObjectFromFile = hubLVideoUtils.getHubLVideoParamObjectFromFile;
export const getHubLVideoPlayerIdFromFile = hubLVideoUtils.getHubLVideoPlayerIdFromFile;
export const getHubLVideoHubLTag = hubLVideoUtils.getHubLVideoHubLTag;
export const getHubLParamsForVideoPlayer = hubLVideoUtils.getHubLParamsForVideoPlayer;